import {Component, input} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {ElciaIcon, IconType} from '../icon/icon';
import {TranslatePipe} from '@ngx-translate/core';
import {Dot} from '../dot/dot';

@Component({
  selector: 'elcia-tabs',
  imports: [
    RouterLink,
    RouterLinkActive,
    ElciaIcon,
    TranslatePipe,
    Dot,
  ],
  templateUrl: './tab-menu.html',
  styleUrl: './tab-menu.scss',
})
export class TabMenu {
  items = input.required<TabItem[]>();
}

export interface TabItem {
  route: string;
  icon: IconType;
  label: string;
  // Flags a tab holding edits that are not saved yet, so it stays visible from the other tabs
  hasPendingChanges?: boolean;
}
